'use strict';
const arrayWithUniqueElements = require('@mindmup/js-utils/src/array-with-unique-elements'),
	observable = require('@mindmup/mapjs-core/src/util/observable'),
	matchingSearch = (aliases, search) => {
		const searchWords = search.split(' ');
		return searchWords.every(word => aliases.find(alias => alias.startsWith(word)));
	},
	filterStickers = (stickersMetadata, search) => {
		const trimmedSearch = search && search.trim().toLowerCase();
		if (!trimmedSearch) {
			return stickersMetadata;
		}
		return stickersMetadata.filter(item => item.aliases && matchingSearch(item.aliases, trimmedSearch));
	};
module.exports = function StickerList() {
	let filter = '', filteredStickers, stickersMetadata;
	const self = observable(this),
		applyFilter = function () {
			if (!stickersMetadata) {
				return;
			}
			filteredStickers = filterStickers(stickersMetadata, filter);
			self.dispatchEvent('changed');
		};
	self.load = function (list) {
		if (!Array.isArray(list)) {
			throw new Error('invalid-args');
		}
		stickersMetadata = list.slice(0);
		applyFilter();
	};
	self.getStickersForCategory = (category) => {
		return filteredStickers.filter(s => s.category === category);
	};
	self.getFirst = () => {
		return filteredStickers[0];
	};
	self.isLoaded = () => !!stickersMetadata;
	self.getCategories = () => {
		if (!stickersMetadata) {
			return [];
		}
		return arrayWithUniqueElements(filteredStickers.map(sticker => sticker.category));
	};
	self.setFilter = function (newFilter) {
		if (newFilter === filter) {
			return;
		};
		filter = (newFilter || '');
		applyFilter();
		self.dispatchEvent('filter-changed', filter);
	};

};
